var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77963 12.27L4.31963 11.98C4.92963 11.91 5.52963 12.12 5.95963 12.55L7.79963 14.39C10.6296 12.95 12.9496 10.64 14.3896 7.79999L12.5396 5.94999C12.1096 5.51999 11.8996 4.91999 11.9696 4.30999L12.2596 1.78999C12.3796 0.779989 13.2296 0.019989 14.2496 0.019989H15.9796C17.1096 0.019989 18.0496 0.959989 17.9796 2.08999C17.4496 10.63 10.6196 17.45 2.08963 17.98C0.959629 18.05 0.0196288 17.11 0.0196288 15.98V14.25C0.0096288 13.24 0.769629 12.39 1.77963 12.27Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneVector);
export default __webpack_public_path__ + "static/media/phoneVector.78991683aa48640b3b5d198c6e3e4e21.svg";
export { ForwardRef as ReactComponent };